module.exports = __webpack_public_path__ + "static/media/hand_leaf.d67caec9.png";